import { render } from "./VR.vue?vue&type=template&id=5db9027a&scoped=true"
import script from "./VR.vue?vue&type=script&lang=js"
export * from "./VR.vue?vue&type=script&lang=js"

import "./VR.vue?vue&type=style&index=0&id=5db9027a&scoped=true&lang=css"

import exportComponent from "/builds/tapetum1/tapetum-landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db9027a"]])

export default __exports__